// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.0011 1.48999L1.81469 8.1643L11.0011 11.1491V1.48999Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M1.19604 10.0662L4.70517 20.8662L10.3831 13.0513L1.19604 10.0662Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.32406 22.0406H17.6781L12.0011 14.2268L6.32406 22.0406Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.2953 20.8638L22.8033 10.0671L13.6191 13.0513L19.2953 20.8638Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.1857 8.16488L13.0011 1.49184V11.1491L22.1857 8.16488Z"}}]};

const ChartRadarFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chart-radar-filled',
    ref,
    icon: element,
  },
));

ChartRadarFilledIcon.displayName = 'ChartRadarFilledIcon';

export default ChartRadarFilledIcon;
